import { SidebarLayout } from '@/layouts/sidebar/SidebarLayout';
import { PageWithLayout } from '@/pages/_app';
import { Helmet } from 'react-helmet-async';
import { Permission } from '@/models/user';
import { VoucherTemplateEditorContent } from '@starjack/widgets/voucherTemplates';

const VoucherTemplateEditor: PageWithLayout = () => {
    return (
        <>
            <Helmet>
                <title>Gutscheinvorlage bearbeiten | Starjack Backoffice</title>
            </Helmet>

            <VoucherTemplateEditorContent />
        </>
    );
};

VoucherTemplateEditor.getLayout = (page) => (
    <SidebarLayout>{page}</SidebarLayout>
);
VoucherTemplateEditor.isProtected = true;
VoucherTemplateEditor.permissions = [Permission.ADMIN];

export default VoucherTemplateEditor;
